module.exports = __webpack_public_path__ + "static/media/3-pos-toe-raises-2.73fe472a.png";